import { Component, input } from '@angular/core';

export type StatusIndicatorStatus = 'UP' | 'DOWN';

@Component({
  selector: 'htx-status-indicator',
  standalone: true,
  templateUrl: './status-indicator.component.html',
  styleUrl: './status-indicator.component.scss'
})
export class StatusIndicatorComponent {
  status = input<StatusIndicatorStatus>('DOWN');
}
